/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ProxySummary,
    ProxySummaryFromJSON,
    ProxySummaryFromJSONTyped,
    ProxySummaryToJSON,
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProxySummariesListResponse
 */
export interface ProxySummariesListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof ProxySummariesListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<ProxySummary>}
     * @memberof ProxySummariesListResponse
     */
    entries: Array<ProxySummary>;
}

export function ProxySummariesListResponseFromJSON(json: any): ProxySummariesListResponse {
    return ProxySummariesListResponseFromJSONTyped(json, false);
}

export function ProxySummariesListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProxySummariesListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(ProxySummaryFromJSON)),
    };
}

export function ProxySummariesListResponseToJSON(value?: ProxySummariesListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(ProxySummaryToJSON)),
    };
}


